import React, { useCallback, useMemo, useState } from 'react'

import { Grid, Typography, Drawer, IconButton } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'

import Svg, { ICON } from '_components/svg'
import HistoryItem from '_components/history-item'
import { ArrowLeft as ArrowLeftIcon } from '@refera/ui-icons'
import { getHistoryLogsSelector, getEventsFilter } from '_modules/history-logs/selectors'

import useStyles from './styles'
import { setEventsFilter } from '_/modules/history-logs/actions'
import classnames from 'classnames'

const EventHistory = () => {
  const styles = useStyles()
  const historyLogs = useSelector(getHistoryLogsSelector)
  const filter = useSelector(getEventsFilter)
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)

  const handleFilter = useCallback(
    name => {
      dispatch(setEventsFilter({ name, value: !filter?.get('mainEvents') }))
    },
    [filter]
  )

  const chipColor = useMemo(
    () => (filter?.get('mainEvents') ? styles.chipEnabled : styles.chipDisabled),
    [filter]
  )

  const renderIcon = !isOpen && (
    <IconButton onClick={() => setIsOpen(!isOpen)} className={styles.menuIcon}>
      <ArrowLeftIcon color="white" />
    </IconButton>
  )

  return (
    <Drawer
      variant="permanent"
      anchor="right"
      className={classnames(
        styles.container,
        isOpen ? styles.containerOpened : styles.containerClosed
      )}
    >
      <Grid className={`${isOpen ? styles.boxShadow : styles.historyHeader}`}>
        {renderIcon}

        <Grid className={styles.historyHeaderTitle}>
          <Svg className={styles.icon} type={ICON.HISTORY} />
          {isOpen && (
            <Typography component="h1" variant="h5" className={styles.timeLine}>
              Linha do tempo
            </Typography>
          )}
        </Grid>

        {isOpen && (
          <>
            <button
              type="button"
              className={`${styles.chip} ${chipColor}`}
              onClick={() => handleFilter('mainEvents')}
            >
              Ver somente principais
            </button>
          </>
        )}
      </Grid>
      {isOpen && (
        <Grid className={styles.content}>
          {historyLogs?.map(
            (item, index) =>
              item?.isActive && (
                <HistoryItem
                  item={item}
                  isLastItem={historyLogs.length - 1 === index}
                  key={`history-item-${item?.id}`}
                />
              )
          )}
        </Grid>
      )}
    </Drawer>
  )
}

export default EventHistory
